import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Loading } from '@sis-cc/dotstatsuite-visions';

const useStyles = makeStyles((theme) => ({
  gutters: {
    display: 'flex',
    margin: 0,
    flexWrap: 'nowrap',
    backgroundColor: theme.palette.background.default,
    marginRight: '-15px',
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
    },
  },
}));

export const Loader = ({ message, styles = {} }) => {
  const classes = useStyles();
  if (!message) return;

  return (
    <div style={{ flexGrow: 1 }}>
      <div style={styles} className={classes.gutters}>
        <Loading message={message} />
      </div>
    </div>
  );
};
